import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/403")({
  component: () => (
    <div className="flex min-h-[70vh] items-center justify-center text-center">
      <div className="max-w-md">
        <h1 className="font-[var(--font-display)] text-3xl font-semibold tracking-tight">
          Access not granted
        </h1>
        <p className="mt-3 text-[var(--iris-fg-3)]">
          You are signed in, but your account does not have the <code>is_ops_staff</code> flag. Ask
          an administrator to grant ops access.
        </p>
      </div>
    </div>
  ),
});
